import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import { CounterExpertiseRequest as CounterExpertiseType } from '../../../../business/models/dto/rim/counter-expertise.request.dto';
import { Dispatch } from 'redux';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './rim.module.css';
import { updateCounterExpertise, setCurrentTabAsDirty } from '../../../../store/details/rim/actions';
import { BelfiusCurrencyInput } from '../../../custom/belfius-currency-input';
import { Role } from '../../../../store/shared/model';

interface PropsFromState {
  readonly counterExpertise: CounterExpertiseType;
  readonly locked: boolean;
}

interface PropsFromDispatch {
  readonly updateValues: typeof updateCounterExpertise;
  readonly setCurrentTabAsDirty: typeof setCurrentTabAsDirty;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class CounterExpertise extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);

    this.localization = getI18n();
  }

  render() {
    return (
      <div>
        <div className={styles.content}>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.rim.counterExpertise.nameTP')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.rim.counterExpertise.nameTP.placeholder')}
                value={this.props.counterExpertise.nameTP}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.updateValues({ ...this.props.counterExpertise, nameTP: event.target.value });
                  this.props.setCurrentTabAsDirty();
                }} />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.rim.counterExpertise.nameTPCompany')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.rim.counterExpertise.nameTPCompany.placeholder')}
                value={this.props.counterExpertise.nameTPCompany}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.updateValues({ ...this.props.counterExpertise, nameTPCompany: event.target.value });
                  this.props.setCurrentTabAsDirty();
                }} />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.rim.counterExpertise.referteTP')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.rim.counterExpertise.referteTP.placeholder')}
                value={this.props.counterExpertise.referteTP}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.updateValues({ ...this.props.counterExpertise, referteTP: event.target.value });
                  this.props.setCurrentTabAsDirty();
                }} />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.rim.counterExpertise.realValue')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <BelfiusCurrencyInput className={styles.input}
                disabled={this.props.locked}
                value={this.props.counterExpertise.realValue}
                placeholder={this.localization.get('details.rim.valueAndCause.value')}
                onChange={() => {
                  this.props.setCurrentTabAsDirty();
                }}
                onValueChange={(values: { value: string }) => {
                  this.props.updateValues({ ...this.props.counterExpertise, realValue: values.value });
                }}
              />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.rim.counterExpertise.nameExpert')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.rim.counterExpertise.nameExpert.placeholder')}
                value={this.props.counterExpertise.counterExpertSignedName ? this.props.counterExpertise.counterExpertSignedName : ''}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.updateValues({ ...this.props.counterExpertise, counterExpertSignedName: event.target.value });
                  this.props.setCurrentTabAsDirty();
                }} />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.rim.counterExpertise.info')}
              </span>
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <textarea className={styles.input}
                    rows={2}
                    maxLength={120}
                    disabled={this.props.locked}
                    placeholder={this.localization.get('details.rim.remark.placeholder')}
                    value={this.props.counterExpertise.comment ? this.props.counterExpertise.comment : ''}
                    autoComplete='off'
                    onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                      this.props.updateValues({ ...this.props.counterExpertise, comment: event.target.value });
                      this.props.setCurrentTabAsDirty();
                    }} />
                </div>
            </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsRim }, caseState: { selectedCase }, shared: { roles } }: ApplicationState): PropsFromState => ({
  counterExpertise: detailsRim.counterExpertise,
  locked: detailsRim.locked === '' ? false : detailsRim.locked || selectedCase.blocked || !roles.includes(Role.ExFiLoAd),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateValues: (counterExpertise: CounterExpertiseType) => dispatch(updateCounterExpertise(counterExpertise)),
  setCurrentTabAsDirty: () => dispatch(setCurrentTabAsDirty())
});

export default connect(mapStateToProps, mapDispatchToProps)(CounterExpertise);
